<template>
  <div class="faq">
    <header-main class="anchored"></header-main>
    <nav-mobile></nav-mobile>
    <section id="faq">
     <header class="subpage">
        <h3>FAQ</h3>
        <h4>Cz<span>ę</span>sto zadawane pytania i odpowiedzi</h4>
      </header>
      <div class="flex" :class="{ bottom: data[0].show == 1 || data[1].show == 1 || data[2].show == 1  }">
        <div class="img"></div>
        <div>
          <article>
            <header :class="{ extend: data[0].show == 1 }">
              <h4 :class="{ extend: data[0].show == 1 }">Co to jest Wirtualne Biuro?</h4>
              <div class="extend" @click="extend(0)">
                <i class="material-icons">{{ icon(0) }}</i>
              </div>
            </header>
            <div class="content" :class="{ extend: data[0].show == 1 }">
              <p><strong>Wirtualne Biuro</strong>, to nowoczesne i w pełni wyposażone <strong>e-biuro</strong> bez ponoszenia wysokich kosztów najmu lokalu. U nas opłacasz jedynie niewielki miesięczny abonament.</p>
              <h5>Świadczymy pełen outsourcing usług administracyjnych, takich jak, np.:</h5>
              <ul>
                <li>rejestracja adresu dla firmy</li>
                <li>odbiór korespondencji</li>
                <li>skanowanie korespondencji</li>
                <li>wynajem sal spotkań </li>
              </ul>
              <p>Tym samym zmniejszasz koszty funkcjonowania firmy, bo nie musisz samodzielnie utrzymywać biura, serwisować drogich urządzeń biurowych i zatrudniać wykwalifikowanych pracowników do jego obsługi.</p>
            </div>
          </article>
          <article>
            <header :class="{ extend: data[1].show == 1 }">
              <h4 :class="{ extend: data[1].show == 1  }">Dla kogo Wirtualne Biuro?</h4>
              <div class="extend" @click="extend(1)">
                <i class="material-icons">{{ icon(1) }}</i>
              </div>
            </header>
            <div class="content" :class="{ extend: data[1].show == 1 }">
              <p><strong>Biuro Wirtualne</strong> to propozycja dla osób, które nie potrzebują stacjonarnego biura, a jedynie adres do rejestracji firmy. Jeśli zatem pracujesz na laptopie, uprawiasz wolny zawód lub dużo podróżujesz i potrzebujesz miejsca wyłącznie do odbioru korespondencji, to <strong>Wirtualne Biuro</strong> jest rozwiązaniem dla Ciebie.</p>
              <p><strong>e-Biuro</strong> to również pomysł na prestiżowy adres dla małej firmy lub startupu. Dotyczy to w szczególności osób prowadzących jednoosobową działalność gospodarczą, zarejestrowaną we własnym mieszkaniu. W <strong>Wirtualnym Biurze</strong> możesz skorzystać z usług naszego sekretariatu oraz wynająć salę konferencyjną na spotkanie biznesowe, rozmowę rekrutacyjną oraz szkolenie. Komfortowo wyposażone sale konferencyjne, w których będziesz mógł spotkać się z kontrahentami lub klientami, podkreślą profesjonalizm Twojej firmy i wpłyną pozytywnie na dalszy jej rozwój.</p>
              <p><strong>Wirtualne Biuro</strong> będzie dobrym wyjściem także wtedy, gdy działasz globalnie w kraju i za granicą. U nas możesz otworzyć odział lub filię Twojej firmy w Polsce.</p>
            </div>
          </article>
          <article>
            <header :class="{ extend: data[2].show == 1 }">
              <h4 :class="{ extend: data[2].show == 1  }">Kim są Klienci Biura Wirtualnego?</h4>
              <div class="extend" @click="extend(2)">
                <i class="material-icons">{{ icon(2) }}</i>
              </div>
            </header>
            <div class="content" :class="{ extend: data[2].show == 1 }">
              <h5>Z usług naszego <strong>Wirtualnego Biura</strong> korzystają najczęściej małe i średnie firmy, w tym:</h5>
              <ul>
                <li>startupy</li>
                <li>informatycy</li>
                <li>freelancerzy</li>
                <li>sklepy internetowe</li>
                <li>agencje marketingowe</li>
                <li>firmy szkoleniowe</li>
                <li>firmy rekrutacyjne</li>
                <li>firmy otwierające oddział lub filię w nowym mieście</li>
                <li>zagraniczne spółki otwierające swoje oddziały, przedstawicielstwa i filie w Polsce.</li>
              </ul>
            </div>
          </article>
        </div>
      </div>
      <article>
        <header :class="{ extend: data[3].show == 1 }">
          <h4 :class="{ extend: data[3].show == 1  }">Na czym polega usługa wynajmu biura na godziny?</h4>
          <div class="extend" @click="extend(3)">
            <i class="material-icons">{{ icon(3) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[3].show == 1 }">
          <p>Wszystkim firmom, które chcą skorzystać z komfortowo wyposażonej przestrzeni biurowej naszego <strong>Wirtualnego Biura</strong>, udostępniamy sale konferencyjne za niewielką opłatą. Można je wynająć na godzinę, kilka godzin lub dni. To doskonała propozycja na szkolenie, spotkanie biznesowe i rozmowy rekrutacyjne. Zapewniamy również obsługę administracyjną tych spotkań, m.in. serwujemy pyszną kawę z ekspresu.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[4].show == 1 }">
          <h4 :class="{ extend: data[4].show == 1  }">Muszę się spotkać z klientami. Czy mogę skorzystać z Wirtualnego Biura?</h4>
          <div class="extend" @click="extend(4)">
            <i class="material-icons">{{ icon(4) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[4].show == 1 }">
          <p>Tak, oczywiście! Możesz skorzystać z naszego <strong>e-Biura</strong> zarówno w ramach wykupionego pakietu, jak i płacąc za każdą godzinę wynajmu sali konferencyjnej. Nasze <strong>Biuro Wirtualne</strong> oferuje komfortowe  pomieszczenia do pracy własnej, na spotkania z klientem, podpisanie umowy, czy przeprowadzenie rozmowy rekrutacyjnej. </p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[5].show == 1 }">
          <h4 :class="{ extend: data[5].show == 1  }">Na czym polega obsługa korespondencji?</h4>
          <div class="extend" @click="extend(5)">
            <i class="material-icons">{{ icon(5) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[5].show == 1 }">
          <p>W <strong>Wirtualnym Biurze</strong> odbieramy korespondencję firmową od listonosza lub kuriera. Wprowadzamy dane nadawcy do naszego systemu i niezwłocznie informujemy Cię o tym mailowo. Jeżeli sobie tego życzysz, dodatkowo otwieramy korespondencję i załączamy jej skan do przesyłanej do Ciebie wiadomości. Dzięki tej usłudze, masz zawsze stały dostęp do firmowej poczty, bez względu na to gdzie jesteś. Oryginały korespondencji odbierasz w dogodnym dla siebie terminie, podczas wizyty w naszym <strong>Wirtualnym Biurze</strong>. Możemy również przesłać korespondencję pocztą lub kurierem na wskazany przez Ciebie adres.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[7].show == 1 }">
          <h4 :class="{ extend: data[7].show == 1  }">Czy firma musi mieć adres?</h4>
          <div class="extend" @click="extend(7)">
            <i class="material-icons">{{ icon(7) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[7].show == 1 }">
            <p>Jeśli zakładasz firmę jednoosobową a twoja działalność polega gównie na wykonywaniu jej u różnych klientów lub usługi, które świadczysz mają charakter mobilny, nie musisz we wniosku rejestracyjnym CEIDG wskazywać adresu miejsca wykonywania działalności. Jedynym wpisanym adresem może być twój adres do doręczeń, np. w <strong>Wirtualnym Biurze</strong> lub tam gdzie mieszkasz.</p>
          </div>
        </article>
      <article>
        <header :class="{ extend: data[8].show == 1 }">
          <h4 :class="{ extend: data[8].show == 1  }">Czy można dzielić ten sam adres z innymi firmami w ramach Wirtualnego Biura?</h4>
          <div class="extend" @click="extend(8)">
            <i class="material-icons">{{ icon(8) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[8].show == 1 }">
          <p>Tak. Taka rejestracja jest zgodna z obowiązującymi przepisami prawa.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[9].show == 1 }">
          <h4 :class="{ extend: data[9].show == 1  }">Czy Wirtualne Biuro pobiera kaucję za wynajem?</h4>
          <div class="extend" @click="extend(9)">
            <i class="material-icons">{{ icon(9) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[9].show == 1 }">
          <p>Nie. Jedyne opłaty jakie ponosisz za <strong>Wirtualne Biuro</strong>, to miesięczny abonament.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[10].show == 1 }">
          <h4 :class="{ extend: data[10].show == 1  }">Na jaki okres zawierana jest umowa Wirtualnego Biura?</h4>
          <div class="extend" @click="extend(10)">
            <i class="material-icons">{{ icon(10) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[10].show == 1 }">
          <p>Standardowa umowa <strong>Wirtualnego Biura</strong> zawierana jest na okres 3, 6, 12 miesięcy.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[11].show == 1 }">
          <h4 :class="{ extend: data[11].show == 1  }">Czy podane ceny są cenami netto?</h4>
          <div class="extend" @click="extend(11)">
            <i class="material-icons">{{ icon(11) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[11].show == 1 }">
          <p>Tak, podane ceny to ceny netto.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[12].show == 1 }">
          <h4 :class="{ extend: data[12].show == 1  }">Czy otrzymam fakturę VAT?</h4>
          <div class="extend" @click="extend(12)">
            <i class="material-icons">{{ icon(12) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[12].show == 1 }">
          <p>Po opłaceniu zamówienia wystawimy fakturę VAT, którą prześlemy na adres e-mail na, które zostało założone konto.</p>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[13].show == 1 }">
          <h4 :class="{ extend: data[13].show == 1  }">Jakie formy płatności są akceptowalne?</h4>
          <div class="extend" @click="extend(13)">
            <i class="material-icons">{{ icon(13) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[13].show == 1 }">
          <h5>Akceptujemy następujące formy płatności:</h5>
          <ul>
            <li>Płatność szybkim przelewem on-line</li>
            <li>Blik</li>
            <li>Przelew tradycyjny</li>
            <li>Karta kredytowa</li>
          </ul>
        </div>
      </article>
      <article>
        <header :class="{ extend: data[14].show == 1 }">
          <h4 :class="{ extend: data[14].show == 1  }">Czy mogę zapłacić przelewem tradycyjnym?</h4>
          <div class="extend" @click="extend(14)">
            <i class="material-icons">{{ icon(14) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[14].show == 1 }">
          <p>Tak, akceptujemy płatności przez przelewy tradycyjne. Wystarczy, że przy płatności wybierzesz Płatności online, a następnie opcję „Przelew tradycyjny”.</p>
        </div>
      </article>
      <article class="org">
        <header :class="{ extend: data[15].show == 1 }">
          <h4 :class="{ extend: data[15].show == 1  }">Jakie są właściwe urzędy ze względu na siedzibę wirtualnego biura?</h4>
          <div class="extend" @click="extend(15)">
            <i class="material-icons">{{ icon(15) }}</i>
          </div>
        </header>
        <div class="content" :class="{ extend: data[15].show == 1 }">
          <h5>Urząd Skarbowy Wrocław-Krzyki</h5>
          <p>ul. Sztabowa 100<br>53-310 Wrocław<br>tel.: 71 7985201<br><a href="https://www.dolnoslaskie.kas.gov.pl/">www.dolnoslaskie.kas.gov.pl</a></p>
          <h5>ZUS</h5>
          <p>ul. Bernarda Pretficza 11<br>50-930 Wrocław<br>tel: 22 560 16 00<br>e-mail: cot@zus.pl<br><a href="https://www.zus.pl/">www.zus.pl</a></p>
          <h5>Krajowy Rejestr Sądowy - VI Wydział Gospodarczy</h5>
          <p>ul. Poznańska 16<br>53-630 Wrocław<br>pok. 100, piętro I<br>fax 71 74 89 216<br>e-mail: VIgospodarczy@wroclaw-fabryczna.sr.gov.pl<br>Biuro Obsługi Interesanta - ul. Poznańska 16,  pokój 3, tel. 71 748 90 00<br>Czytelnia (zamawianie akt) - ul. Poznańska 16,  pokój 2, tel. 71 748 90 00<br>Biuro podawcze - ul. Poznańska 16,  pokój 1, tel. 71 748 90  00<br><a href="https://www.wroclaw-fabryczna.sr.gov.pl/">www.wroclaw-fabryczna.sr.gov.pl</a></p>
          <h5>Urząd Statystyczny we Wrocławiu</h5>
          <p>ul. Oławska 31,<br>50-950 Wrocław<br>Centrala telefoniczna<br>tel.: (+48) 71 3716 300<br>Sekretariat<br>tel.: (+48) 71 3716 400<br>faks: (+48) 71 3716 360<br>e-mail: sekretariatuswro@stat.gov.pl<br><a href="https://wroclaw.stat.gov.pl/">wroclaw.stat.gov.pl</a></p>
        </div>
      </article>
      <div class="icon-circle" :title="toggleTitle" @click="toggleAll()">
        <i class="material-icons">{{ toggleIcon }}</i>
      </div>
    </section>
    <footer-main></footer-main>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'Faq',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
  },
  data(){
    return{
      data: [],
      count: 16,
      toggle: 1,
      toggleIcon: 'keyboard_arrow_down',
      toggleTitle: 'Rozwiń wszystkie',
    }
  },
  created(){
    for(let i = 0; i < this.count; i++){
      this.data.push({ show: 0 })
    }
  },
  methods:{
    extend(id){
      if(this.data[id].show){
        this.data[id].show = 0;
      }else{
        this.data[id].show = 1;
      }
    },
    icon(id){
      if(this.data[id].show){
        return 'keyboard_arrow_up'
      }else{
        return 'keyboard_arrow_down'
      }
    },
    toggleAll(){
      for(let i = 0; i < this.count; i++){
        this.data[i].show = this.toggle;
      }
      if(this.toggle){
        this.toggleIcon = 'keyboard_arrow_up';
        this.toggleTitle = 'Zwiń wszystkie';
        this.toggle = 0;
      }else{
        this.toggleIcon = 'keyboard_arrow_down';
        this.toggleTitle = 'Rozwiń wszystkie';
        this.toggle = 1;
      }
    },

  }
}
</script>
<style scoped lang="scss">
  section#faq { overflow: hidden; }
  section#faq div.flex { display: flex; align-items: center; width: 65vw; margin: 20px auto -20px auto; }
  section#faq div.flex.bottom { align-items: flex-end; }
  section#faq div.flex div { width: calc(100% - 372px); }
  section#faq div.flex article { width: 100%; }
  section#faq div.flex article div.content.extend { width: 100%; }
  section#faq div.flex div.img { width: 431px; height: 590px; background: url('../assets/faq_small.webp') no-repeat 50% 50%; flex-shrink: 0; }
  section#faq article { margin: 20px auto; width: 65%; border-radius: 5px; background: #fff; box-shadow: none; }
  section#faq article header { display: flex; justify-content: space-between; align-items: center; padding: 5px 15px; background: rgba(228, 228, 230, 1); border-radius: 5px; }
  section#faq article header.extend { border-bottom-right-radius: 0; border-bottom-left-radius: 0; }
  section#faq article header h4 { margin: 0px 0; padding: 0; font-weight: 400; font-size: 18px; color: $fontBlack; }
  section#faq article header div.extend { display: flex; justify-content: center; align-items: center; width: 50px; height: 50px; cursor: pointer; flex-shrink: 0; }
  section#faq article header div.extend i.material-icons { font-size: 36px; color: $orangeLight; }
  section#faq article div.content { display: none; padding: 0 40px; overflow: hidden; box-shadow: none; border: 1px solid rgba(210, 210, 212, 1); }
  section#faq article div.content.extend { display: block; }
  section#faq article h5 { margin: 15px 0 0 0; padding: 0; font-weight: 500; color: $fontBlack; font-size: 16px; }
  section#faq article p { margin: 30px 0; padding: 0; color: $fontBlack; font-size: 16px; }
  section#faq article p strong { font-weight: 600; color: #000; }
  section#faq article ul { margin: 30px 40px; padding: 0; }
  section#faq article ul li { color: $fontBlack; font-size: 17px; }
  section#faq article.org p { margin: 15px 0; }

  div.icon-circle { display: flex; justify-content: center; align-items: center; width: 50px; height: 50px; border-radius: 50%; position: fixed; bottom: 25px; right: 25px; 
    background: $orangeDark; box-shadow: 0 0 7px rgba(0, 0, 0, 0.2); cursor: pointer; }
  div.icon-circle i.material-icons { font-size: 34px; color: #fff; }

  section#faq article header { padding: 2px 15px; }
  section#faq article header h4 { font-size: 17px; }
  section#faq article div.content { padding: 0 20px; }
  section#faq article ul { margin: 20px 40px; }
  section#faq article h5 { font-size: 16px; }

  @media (max-width: 1100px) {
    section#faq div.flex div.img { display: none; }
    section#faq div.flex { width: calc(100vw - 40px); margin: 0 auto -20px auto; }
    section#faq div.flex div { width: 100%; }
    section#faq article { width: calc(100vw - 40px); }
  }
</style>
